import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import './Admin.css';

const ORDER_STATUSES = ['pending', 'confirmed', 'processing', 'shipped', 'delivered', 'cancelled'];
const STATUS_COLORS = { pending: '#f59e0b', confirmed: '#3b82f6', processing: '#8b5cf6', shipped: '#06b6d4', delivered: '#10b981', cancelled: '#ef4444' };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/admin/orders?status=${statusFilter}&limit=50`);
        setOrders(res.data.orders);
      } catch { toast.error('Failed to load orders'); }
      finally { setLoading(false); }
    };
    fetchOrders();
  }, [statusFilter]);

  const updateStatus = async (orderId, orderStatus, trackingNumber) => {
    try {
      const res = await api.put(`/admin/orders/${orderId}/status`, { orderStatus, trackingNumber });
      setOrders(prev => prev.map(o => o._id === orderId ? res.data.order : o));
      if (selected?._id === orderId) setSelected(res.data.order);
      toast.success('Order updated!');
    } catch { toast.error('Update failed'); }
  };

  const filtered = orders.filter(o =>
    !search || o.orderNumber?.toLowerCase().includes(search.toLowerCase()) ||
    o.user?.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-page">
      <div className="admin-header"><h1>Orders</h1></div>
      <div className="admin-card">
        <div className="admin-toolbar">
          <div className="admin-search"><Search size={16} /><input placeholder="Search by order # or email..." value={search} onChange={e => setSearch(e.target.value)} /></div>
          <select className="status-select" style={{ padding: '10px 14px' }} value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
            <option value="">All Statuses</option>
            {ORDER_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>

        {loading ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div> : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead><tr><th>Order</th><th>Customer</th><th>Date</th><th>Total</th><th>Payment</th><th>Status</th><th>Update</th></tr></thead>
              <tbody>
                {filtered.map(order => (
                  <tr key={order._id}>
                    <td><strong style={{ color: 'var(--primary)' }}>{order.orderNumber}</strong></td>
                    <td>
                      <div><strong style={{ fontSize: 13 }}>{order.user?.name || 'Guest'}</strong></div>
                      <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>{order.user?.email}</div>
                    </td>
                    <td style={{ fontSize: 13, color: 'var(--gray-500)' }}>{new Date(order.createdAt).toLocaleDateString()}</td>
                    <td><strong>CHF {order.total?.toFixed(2)}</strong></td>
                    <td>
                      <span style={{ background: order.paymentStatus === 'paid' ? '#10b98122' : '#f59e0b22', color: order.paymentStatus === 'paid' ? '#10b981' : '#f59e0b', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{order.paymentStatus}</span>
                    </td>
                    <td><span style={{ color: STATUS_COLORS[order.orderStatus], fontWeight: 700, fontSize: 13, textTransform: 'capitalize' }}>● {order.orderStatus}</span></td>
                    <td>
                      <select className="status-select" value={order.orderStatus} onChange={e => updateStatus(order._id, e.target.value, order.trackingNumber)}>
                        {ORDER_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
